import { render, staticRenderFns } from "./OrdersNewDetail.vue?vue&type=template&id=5a5dabc5&scoped=true&"
import script from "./OrdersNewDetail.vue?vue&type=script&lang=js&"
export * from "./OrdersNewDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrdersNewDetail.vue?vue&type=style&index=0&id=5a5dabc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5dabc5",
  null
  
)

export default component.exports